module.exports = __webpack_public_path__ + "static/media/plan-C2b-mobile-tc.af5940ef.png";